/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_InspectorInputs */

const en_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Inspector`)
};

const es_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de página`)
};

const fr_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur de page`)
};

const de_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seiten-Inspektor`)
};

const ja_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページインスペクター`)
};

const zh_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面检查器`)
};

const ar_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فاحص الصفحة`)
};

const id_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektur Halaman`)
};

const it_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizzatore pagina`)
};

const ru_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инспектор страниц`)
};

const pt_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de página`)
};

const ko_page_inspector = /** @type {(inputs: Page_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 속성`)
};

/**
* | output |
* | --- |
* | "Page Inspector" |
*
* @param {Page_InspectorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_inspector = /** @type {((inputs?: Page_InspectorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_InspectorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_inspector(inputs)
	if (locale === "es") return es_page_inspector(inputs)
	if (locale === "fr") return fr_page_inspector(inputs)
	if (locale === "de") return de_page_inspector(inputs)
	if (locale === "ja") return ja_page_inspector(inputs)
	if (locale === "zh") return zh_page_inspector(inputs)
	if (locale === "ar") return ar_page_inspector(inputs)
	if (locale === "id") return id_page_inspector(inputs)
	if (locale === "it") return it_page_inspector(inputs)
	if (locale === "ru") return ru_page_inspector(inputs)
	if (locale === "pt") return pt_page_inspector(inputs)
	return ko_page_inspector(inputs)
});